import React, {useCallback} from 'react';
import {useI18n} from '../../../../../../data/hooks/i18nHooks';
import {useFavoritedParticipants} from '../../../../../../data/hooks/participant/useFavoritedParticipants';
import StartNetworkingStep from '../../../StartNetworkingStep/StartNetworkingStep';
import {useDispatch} from 'react-redux';

function StepViewFavorites(props) {
    const {eventId} = props,
        i18n = useI18n(),
        favorites = useFavoritedParticipants(eventId),
        dispatch = useDispatch();

    const handleClick = useCallback(() => {
        dispatch(app.actions.participants.setFilterParams(eventId, {favorites: true}));
    }, []);

    return (
        <StartNetworkingStep href={['/events', eventId, 'participants'].join('/')} visible={favorites.length > 0} onClick={handleClick}>
            {i18n['start.view_favorites']}
        </StartNetworkingStep>
    );
}

export default StepViewFavorites;
